export default __webpack_public_path__ + "static/media/settings.809bd592.svg";